module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/icon_rotate_48x48_hover.1e032e91.svg";